import { IntlShape } from "react-intl"
import { CUSTOMER_BEHAVIOR, TRANSACTIONAL } from "constants/paths"
import CustomerBehaviorModule from "navigation/config/CustomerBehaviorModule"
import { isFeatureEnabled } from "config/feature-flags"
import { hasUserAccess } from "helpers/accessPrivilegesUtils"

export const getMenuOptionsForUser = (intl: IntlShape) => {
	return getMenuOptions(intl)
		.filter(({ featureFlag }) => isFeatureEnabled(featureFlag))
		.filter(({ policies }) => hasUserAccess(policies))
}

const getMenuOptions = (intl: IntlShape) => {
	return [
		{
			id: "transactional",
			featureFlag: "transactional",
			to: TRANSACTIONAL,
			title: intl.formatMessage({
				id: "phronesis.menu.option.transactional.title",
			}),
			icon: "icon_transactional",
		},
		{
			id: "customer-behavior",
			featureFlag: "customerBehavior",
			to: CUSTOMER_BEHAVIOR,
			title: intl.formatMessage({
				id: "phronesis.menu.option.customerbehavior.title",
			}),
			icon: "icon_customer_behavior",
			policies: CustomerBehaviorModule.policies,
		},
	]
}

export interface OptionData {
	id: string
	featureFlag: string
	to: string
	title: string
	icon: string
}

export interface MenuOptionData {
	pathName: string
	option: OptionData
}
